<div
  class="identifier"
  [matTooltip]="username"
  (mouseenter)="loadFullUsername()"
  matTooltipPosition="above"
>
  <div class="identifier-icon flex flex-row justify-center items-center">
    <ng-container [ngSwitch]="identifierType">
      <ng-container *ngSwitchCase="CustomerIdentifierType.System"
        ><mat-icon>computer</mat-icon></ng-container
      >
      <ng-container *ngSwitchCase="CustomerIdentifierType.Supporter"
        ><mat-icon>headset_mic</mat-icon></ng-container
      >
      <ng-container *ngSwitchCase="CustomerIdentifierType.Maintainer"
        ><mat-icon>build</mat-icon></ng-container
      >
      <ng-container *ngSwitchDefault><mat-icon>person</mat-icon></ng-container>
    </ng-container>
  </div>
</div>
